export default __webpack_public_path__ + "static/media/down-arrow-png-image.472a0b51.png";